import { createEvent, sample } from 'effector';
import { alertsRefreshed } from '../entities/alert';
import { instrumentsRefreshed } from '../entities/instrument';
import { marketRefreshed } from '../entities/market';
import { positionChanged, positionsRefreshed } from '../entities/position';
import { loadPreferencesFx, systemThemeChanged } from '../entities/preferences';
import { checkSessionFx, sessionExpired, signOutFx, signedIn } from '../entities/session';
import { router, routes } from '../shared/routing';
import { liveStarted, liveStopped } from './live';

export const appStarted = createEvent();

sample({ clock: appStarted, target: checkSessionFx });

// Theme follows the OS when set to "system".
appStarted.watch(() => {
  window.matchMedia('(prefers-color-scheme: light)').addEventListener('change', () => {
    systemThemeChanged();
  });
});

// Signed in: load everything once, then keep it live.
sample({
  clock: signedIn,
  target: [
    loadPreferencesFx,
    positionsRefreshed,
    alertsRefreshed,
    marketRefreshed,
    instrumentsRefreshed,
    liveStarted,
  ],
});

// Recording a fill or a sale resolves alerts on the server.
sample({ clock: positionChanged, target: alertsRefreshed });

// Signed out, every URL shows the homepage (app/App.tsx), so signing in needs no redirect.
sample({
  clock: signedIn,
  source: router.$activeRoutes,
  filter: (active) => active.includes(routes.signIn),
  fn: () => undefined,
  target: routes.positions.open,
});

sample({ clock: [sessionExpired, signOutFx.finally], target: liveStopped });
// After signing out, land on a clean URL rather than the page that was open.
sample({ clock: signOutFx.finally, fn: () => undefined, target: routes.positions.open });
